import type { WidgetOptions } from '../dashboardTypes';

/** Shared visibility rule for all-instance port pickers (motors, mechanisms, sensors). */
export function shouldShowAllPortPicker(allPortsFlag: boolean | undefined, pickerEntries: readonly unknown[]): boolean {
  return Boolean(allPortsFlag) && pickerEntries.length > 1;
}

/** Show the motor/mechanism port picker for all-instance widgets when multiple ports exist in the project. */
export function shouldShowAllMotorPortPicker(options: Pick<WidgetOptions, 'allMotorPorts'> | undefined, pickerEntries: readonly unknown[]): boolean {
  return shouldShowAllPortPicker(options?.allMotorPorts, pickerEntries);
}

/** Show the sensor port picker for all-instance widgets when multiple sensors of the same type exist. */
export function shouldShowAllSensorPortPicker(
  options: Pick<WidgetOptions, 'allSensorPorts'> | undefined,
  pickerEntries: readonly unknown[]
): boolean {
  return shouldShowAllPortPicker(options?.allSensorPorts, pickerEntries);
}

/** Stable useMemo dep when layout JSON yields a new array reference with the same ports (order normalized). */
export function sortedPortsKey(ports: readonly number[] | undefined): string {
  if (!ports?.length) return '';
  return [...ports].sort((a, b) => a - b).join(',');
}

/** Stable useMemo dep for metric lists; preserves caller order (series/stream key order follows this array). */
export function orderedMetricsKey(metrics: readonly string[] | undefined): string {
  if (!metrics?.length) return '';
  return metrics.join(',');
}
